<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper">
        <q-uploader ref="uploader"
                    :float-label="label | capitalize"
                    :url="url"
                    :color="color"
                    :method="method"
                    :extensions="extensions"
                    :multiple="multiple"
                    :headers="headers"
                    hide-upload-button
                    auto-expand
                    :clearable="clearable"
                    :disable="uploading || disable"
                    @uploaded="onSuccess"
                    @fail="onFail"
                    @add="addImage"
                    :no-thumbnails="true"></q-uploader>
        <div class="preview-image" v-if="this.urlImage">
            <button type="button" @click="deleteImage">
                <i aria-hidden="true" class="q-icon q-if-control material-icons">cancel</i>
            </button>
            <img height="150" :src="`/storage/uploads/${this.urlImage}`" />            
        </div>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import {QUploader} from 'quasar-framework'
    import store from '../../store'

    // Get the response interceptors from axios plugin
    import axios from 'axios'
    let responseInterceptors = axios.interceptors.response.handlers

    export default {
        name: 'VImage',

        mixins,

        props: {
            value: {},
            url: {
                type: String,
                required: true
            },
            method: {
                type: String,
                default: 'POST'
            },
            extensions: {
                type: String,
                default: '.jpeg, .jpg, .png'
            },
            multiple: Boolean
        },

        components: {
            QUploader
        },

        data() {
            return {
                uploader: {},
                urlImage: this.value
            }
        },

        mounted() {
            this.uploader = this.$refs.uploader
        },

        computed: {
            uploading() {
                return this.uploader.uploading
            },

            headers() {
                var headers = {}

                const token = store.getters['auth/token']
                if (token)
                    headers['Authorization'] = `Bearer ${token}`

                const locale = store.getters['lang/locale']
                if (locale)
                    headers['Accept-Language'] = locale

                return headers
            }
        },

        methods: {
            onSuccess(file, xhr) {
                this.$emit("uploaded", xhr)

                const responde = JSON.parse(xhr.response);

                this.urlImage = responde.image

                this.$emit("input", this.urlImage)
            },

            onFail(file, xhr) {
                responseInterceptors.forEach(interceptor => interceptor.rejected({
                    response: {
                        status: xhr.status
                    }
                }))
            },

            addImage() {
                this.$refs.uploader.upload()
            },

            deleteImage() {
                this.urlImage = null
                this.$emit("input", null)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VImage.vue